import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import DOMPurify from "dompurify";
import host from "../../global";
import EmailLoader from "../EmailSentLoader";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";

import {
  CheckCircle,
  AlertCircle,
  Mail,
  User,
  XCircle,
  CheckCircle2,
  Dot,
  ArrowLeft,
  ChevronDown,
  FileText,
  Save,
  LoaderCircle,
  XIcon,
  X,
} from "lucide-react";
import TimeFrameSelector from "../TimeFrameSelector";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  Box,
  Button,
} from "@mui/material";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../Loader";
import { Skeleton } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { buildStyles, CircularProgressbar } from "react-circular-progressbar";
import "../../css/platformCalendar.css";
import { useTheme } from "../../hooks/useTheme";
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { useSelector } from "react-redux";
import LimitExceededModal from "./LimitExceededModal";
import ModernScheduleInterview from "./ModernScheduleInterview";
import ct from 'countries-and-timezones';
import HelpVideoModal from "./HelpVideoModal";
import { HELP_VIDEOS } from "../../config/helpVideos";
import { saveDraftCandidateService, bulkUploadService, parseResumeService } from "../../Services/AnalyseResume.service";
import { confirmCompanyDetails, useCompanyDetailsGate } from "../../utils/companyProfileCheck";

const CheckResumeOrgAdmin = () => {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [isEmailLoading, setEmailLoading] = useState(false);
  const [jobPositions, setJobPositions] = useState({});
  const [isJobPositionOpen, setIsJobPositionOpen] = useState(false);
  const [customQuestions, setCustomQuestions] = useState([]);
  const [assessmentSequence, setAssessmentSequence] = useState([]);
  const [selectedJobPosition, setSelectedJobPosition] = useState("");
  const [selectedID, setSelectedID] = useState("");
  const [jobDescription, setJobDescription] = useState("");
  const [rawJD, setRawJD] = useState({});
  const [resume, setResume] = useState(null);
  const [responseReport, setResponseReport] = useState({});
  const [jobId, setJobId] = useState("");
  const [responseScore, setResponseScore] = useState(0);
  const [interviewID, setInterviewID] = useState("");
  const [resumeName, setResumeName] = useState("");
  const [name, setName] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [emailID, setEmailID] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const [isCheckboxChecked, setIsCheckboxChecked] = useState(false);
  const [isConfirmClicked, setIsConfirmClicked] = useState(false);
  const [resumeContent, setResumeContent] = useState("");
  const [selectedInterviewType, setSelectedInterviewType] = useState("");
  const [interview_timelimit, setInterviewTimeLimit] = useState(0);
  const [selectedMCQSet, setSelectedMCQSet] = useState("");
  const [selectedBehavioralSet, setSelectedBehavioralSet] = useState("");
  const [codingJudgingCriteria, setCodingJudgingCriteria] = useState([]);
  const [selectedCodingSet, setSelectedCodingSet] = useState("");
  const [resumeScoreThreshold, setResumeScoreThreshold] = useState(60);
  const [timeFrame, setTimeFrame] = useState({
    startDate: new Date(),
    endDate: new Date(new Date().setDate(new Date().getDate())),
  });
  const [MCQTimeLimit, setMCQTimeLimit] = useState(0);
  const [CodingTimeLimit, setCodingTimeLimit] = useState(0);
  const accessToken = sessionStorage.getItem("accessToken");
  const [isPositionsLoading, setIsPositionsLoading] = useState(false);
  const [isScanning, setIsScanning] = useState(false);
  const [scanProgress, setScanProgress] = useState(0);
  const [scanPhase, setScanPhase] = useState("");
  const [typingTimeLimit, setTypingTimeLimit] = useState(0);
  const [isBulkUpload, setIsBulkUpload] = useState(false);
  const [allSkills, setAllSkills] = useState([]);
  const [resumeS3Url, setResumeS3Url] = useState("");
  const [isDiscardPopupOpen, setIsDiscardPopupOpen] = useState(false);
  const [isViewJd, setIsViewJd] = useState(false);
  const [customizedJdText, setCustomizedJdText] = useState("");
  const [currentJobDescriptionType, setCurrentJobDescriptionType] = useState("");
  const [isSchedulePopup, setIsSchedulePopup] = useState(false);
  // The company name question comes before the date and time, not after
  const schedulePopupOpen = useCompanyDetailsGate(isSchedulePopup, () => setIsSchedulePopup(false));
  const [dateRange, setDateRange] = useState([null, null]);
  const [searchMode, setSearchMode] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [isSavingDraft, setIsSavingDraft] = useState(false);
  const [isDiscarding, setIsDiscarding] = useState(false);
  const [selectedStyle, setSelectedStyle] = useState("");
  const [isUploading, setIsUploading] = useState(false);
  const [limitModal, setLimitModal] = useState({ open: false, featureKey: null });
  const [isHelpVideoOpen, setIsHelpVideoOpen] = useState(false);
  const [mobile , setMobile] = useState("");
  const navigate = useNavigate();

  const jobPositionDropdownRef = useRef(null);
  const searchInputRef = useRef(null);
  const dropdownListRef = useRef(null);
  const hasAutoSelectedRef = useRef(false);
  const jdRef = useRef(null);
  const org_id = useSelector((state)=>state.userSlice.org_id);

  const {theme} = useTheme();

  const sortedFilteredPositions = Object.entries(jobPositions)
  .filter(([_, pos]) =>
    searchQuery
      ? pos.job_role.toLowerCase().includes(searchQuery.toLowerCase())
      : true
  )
  .sort(([, a], [, b]) => {
    const dateA = new Date(a.posting_date ?? 0);
    const dateB = new Date(b.posting_date ?? 0);
    return dateB - dateA; // newest first
  });

  const scanPhases = [
    "Initializing AI Scanner...",
    "Analyzing Document Structure...",
    "Extracting Key Information...",
    "Processing Experience Data...",
    "Evaluating Skills Matrix...",
    "Finalizing Analysis...",
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        jobPositionDropdownRef.current &&
        !jobPositionDropdownRef.current.contains(event.target)
      ) {
        setIsJobPositionOpen(false);
        setSearchMode(false);
        setSearchQuery("");
        setSelectedIndex(-1);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Clear search when dropdown closes
  useEffect(() => {
    if (!isJobPositionOpen) {
      setSearchMode(false);
      setSearchQuery("");
      setSelectedIndex(-1);
    }
  }, [isJobPositionOpen]);

  // Handle clicks outside JD modal
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (jdRef.current && !jdRef.current.contains(event.target)) {
        setIsViewJd(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (isScanning) {
      const interval = setInterval(() => {
        setScanProgress((prev) => {
          if (prev >= 100) {
            clearInterval(interval);
            setIsUploading(false)
            return 100;
          }
          return prev + 0.5;
        });
      }, 50);
      return () => clearInterval(interval);
    }
  }, [isScanning]);

  const handleMobileChange = (value) => {
    setMobile(value || "");
  };

  useEffect(() => {
    if (isScanning) {
      const phaseIndex = Math.floor((scanProgress / 100) * scanPhases.length);
      setScanPhase(scanPhases[Math.min(phaseIndex, scanPhases.length - 1)]);
    }
  }, [scanProgress, isScanning]);

  useEffect(() => {
    setIsPositionsLoading(true);
    const fetchJobPositions = async () => {
      try {
        const response = await axios.get(`${host}/getjdpositions`, {
          headers: {
            Authorization: `Bearer ${accessToken.toString()}`,
          },
        });
        // console.log("API Response:", response.data);
        const jobDescriptions = response.data || {};

        const activeJobPositions = Object.entries(jobDescriptions)
          .filter(([_, jd]) => {
            const isActive = jd.jd_status?.toLowerCase() === "active";

            // For V2 jobs: must be both active AND finalized
            if (jd.job_description_type === "v2") {
              const isFinalized = jd.status === "finalized";
              return isActive && isFinalized;
            }

            // For V1 jobs: just check active status
            return isActive;
          })
          .reduce((acc, [jd_id, jd]) => {
            acc[jd_id] = {
              job_role: jd.job_role,
              jd_status: jd.jd_status,
              posting_date: jd.posting_date,
              experience_required: jd.experience_required,
              job_description_type: jd.job_description_type,
            };
            return acc;
          }, {});
        // console.log("Active Job Positions:", activeJobPositions);
        setJobPositions(activeJobPositions);
        setIsPositionsLoading(false);
      } catch (error) {
        // console.error("Error fetching job positions:", error);
        if (error.response) {
          const status = error.response.status;
          const detail = error.response.data.detail || "Unknown error";
          if (status === 401) {
            await new Promise((resolve) => {
              sessionStorage.removeItem("accessToken");
              resolve();
            });
            toast.error(`Unauthorized: ${detail}`);
          } else if (status === 404) {
            toast.warning(`Not Found: ${detail}`);
          } else {
            toast.error(`Error: ${detail}`);
          }
        } else {
          toast.error("An unexpected error occurred. Please try again.");
        }
        setIsPositionsLoading(false);
      }
    };
    fetchJobPositions();
  }, [accessToken]);

  useEffect(() => {
    if (hasAutoSelectedRef.current) {
      return;
    }

    if (
      location.state?.selectedJobId &&
      location.state?.autoSelectJob &&
      location.state?.jobPosition
    ) {
      const jobId = location.state.selectedJobId;
      const jobPosition = location.state.jobPosition;

      hasAutoSelectedRef.current = true;

      setJobPositions(prev => ({
        ...prev,
        [jobId]: jobPosition
      }));

     handleJobPositionChange({ target: { value: jobId } }, jobPosition);
    }
    else if (
      location.state?.selectedJobId &&
      location.state?.autoSelectJob &&
      jobPositions[location.state.selectedJobId]
    ) {
      const jobId = location.state.selectedJobId;
      hasAutoSelectedRef.current = true;

      handleJobPositionChange({ target: { value: jobId } });
    }
  }, [location.state, jobPositions]);

  useEffect(() => {
    if (resume && selectedJobPosition && jobDescription && jobId) {
      handleSubmit({ preventDefault: () => {} });
    }
  }, [resume, selectedJobPosition, jobDescription, jobId]);

  const handleEmailChange = (e) => {
    setEmailID(e.target.value);
  };

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const handleDiscardConfirm = () => {
    setIsDiscardPopupOpen(false);
    resetResumeState();
  };

  const handleDiscardCancel = () => {
    setIsDiscardPopupOpen(false);
  };

  
const saveDraft = async () => {
  if (!mobile || !isValidPhoneNumber(mobile)) {
    toast.error("Please enter a valid phone number with country code");
    return;
  }
  setIsSavingDraft(true);

  try {
    await saveDraftCandidateService(
      {
        name, emailID, mobile, jobId, selectedJobPosition, jobDescription,
        resumeContent, responseScore, selectedInterviewType, interview_timelimit,
        resumeS3Url, selectedMCQSet, selectedBehavioralSet, selectedCodingSet, MCQTimeLimit, CodingTimeLimit,
        typingTimeLimit, codingJudgingCriteria,
        selectedID, responseReport, customQuestions,
      },
      accessToken
    );
    toast.success("Candidate data saved as draft successfully!");
    setTimeout(() => window.location.reload(), 2000);
  } catch (error) {
    if (error.response) {
      const { status, data: { detail } } = error.response;
      if (status === 401) {
        sessionStorage.removeItem("accessToken");
        toast.error(`Unauthorized: ${detail}`);
      } else if (status === 404) {
        toast.warning(`Not Found: ${detail}`);
      } else {
        toast.error(`Error: ${detail}`);
      }
    } else {
      toast.error("An unexpected error occurred. Please try again.");
    }
  } finally {
    setIsSavingDraft(false);
  }
};

  //CustomizedJDChanges changes to display required Skills as per JD
  const handleJobPositionChange = async (e, passedJobPosition = null) => {
    const selectedPosition = passedJobPosition || jobPositions[e.target.value];
    setSelectedID(e.target.value);
    if (selectedPosition !== "" && selectedPosition !== undefined) {
      setSelectedJobPosition(selectedPosition.job_role);
      setJobDescription("");
      setRawJD({});
      setCustomizedJdText("");
      setCurrentJobDescriptionType("");
      if (Object.keys(responseReport).length > 0) {
        resetResumeState();
      }
      setResponseReport({});
      setResponseScore(0);
      setInterviewID("");
      setIsSubmitting(false);
      setEmailID("");
      setIsVisible(false);
      setIsCheckboxChecked(false);
      setIsConfirmClicked(false);
      setResumeContent("");
      setResumeS3Url("");
      setIsLoading(true);

      try {
        const response = await axios.get(`${host}/getjd`, {
          headers: {
            Authorization: `Bearer ${accessToken.toString()}`,
          },
          params: {
            jd_id: e.target.value,
          },
        });

        if (response) {
          const description = response.data.description;

          if (response.data.jobDescriptionType === "customized") {
            // console.log(" Loading GUIDED JD format");

            const skillBasedData =
              description.Required_Skills?.skill_based || [];
            const allSkills = skillBasedData.flatMap((skill) => {
              return [skill.skill_name, ...(skill.topics || [])];
            });
            setAllSkills(allSkills);
          } else {
            // console.log("📝 Loading LEGACY JD format");

            const formattedSkills = Object.values(
              description.Required_Skills || {}
            )
              .flat(2)
              .filter(Boolean);
            setAllSkills(formattedSkills);
          }

          setJobId(response.data.id);
          setJobDescription(description);
          setCurrentJobDescriptionType(response.data.jobDescriptionType || "");
          if (response.data.jobDescriptionType === "customized") {
            setCustomizedJdText(response.data.jobDescription || "");
          } else {
            setCustomizedJdText("");
          }
          setRawJD({
            ...response.data.rawJD,
            GoodtoHave: description.GoodtoHave || [],
            Tools_and_Technologies: description.Tools_and_Technologies || [],
          });
          setCodingTimeLimit(response.data.coding_time_limit);
          setMCQTimeLimit(response.data.mcq_time_limit);
          setInterviewTimeLimit(response.data.interview_timelimit);
          setSelectedInterviewType(response.data.interview_type);
          setSelectedCodingSet(response.data.Coding_set);
          setSelectedMCQSet(response.data.mcq_set_id);
          setSelectedBehavioralSet(response.data.selected_behavioral_set || "");
          setCodingJudgingCriteria(response.data.Coding_Judge_Criteria);
          setTypingTimeLimit(response.data.typing_time_limit || 0);
          setCustomQuestions(response.data.customQuestions || []);
          setAssessmentSequence(response.data.assessment_sequence || []);
          setSelectedStyle(response.data.questionType || "");
        }
      } catch (error) {
        if (error.response) {
          const status = error.response.status;
          const detail = error.response.data.detail;
          if (status === 401) {
            await new Promise((resolve) => {
              sessionStorage.removeItem("accessToken");
              resolve();
            });
            toast.error(`Unauthorized: ${detail}`);
          } else if (status === 404) {
            toast.warning(`Not Found: ${detail}`);
          } else {
            toast.error(`Error: ${detail}`);
          }
        } else {
          toast.error("An unexpected error occurred. Please try again.");
        }
        setJobDescription("");
      } finally {
        setIsLoading(false);
      }
    }
  };

  const SkillBadge = ({ skill, status }) => {
    return (
      <div className="flex items-center gap-1.5">
        <span className="dark:text-gray-300 text-textSecondary">{skill}</span>
        {status === "yes" ? (
          <CheckCircle className="w-4 h-4 text-green-500" />
        ) : (
          <XCircle className="w-4 h-4 text-red-500" />
        )}
      </div>
    );
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const droppedFile = event.dataTransfer.files[0];
    handleFileValidation(droppedFile);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleFileChange = (e) => {
    // setIsUploading(true);
    const file = e.target.files[0];

    if (file) {
      const maxZipSize = 90 * 1024 * 1024; // 90 MB
      const fileName = file.name.toLowerCase();

      // Check if the file is a .zip file
      const isZip = fileName.endsWith(".zip");

      if (isZip && file.size > maxZipSize) {
        alert("ZIP files must be less than or equal to 90 MB.");
        e.target.value = ""; // Clear the input
        return;
      }

      // Proceed to validate all files (including .pdf, .docx)
      handleFileValidation(file);
    }
    // setIsUploading(false);
  };

  const handleFileValidation = (file) => {
    setIsUploading(true);
    if (!file) {
      setResume(null);
      setResumeName("");
      setResumeS3Url("");
      toast.error("Please select a file.");
      // setIsUploading(false);
      return;
    }

    const fileName = file.name;
    const fileExtension = fileName.split(".").pop().toLowerCase();

    if (fileExtension === "zip") {
      setIsBulkUpload(true);
      setResume(file);
      setResumeName(fileName);
      setResumeS3Url("");
    } else if (
      [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ].includes(file.type)
    ) {
      setIsBulkUpload(false);
      setResume(file);
      setResumeName(fileName);
      setResumeS3Url("");
    } else {
      setResume(null);
      setResumeName("");
      setResumeS3Url("");
      toast.error("File Not Supported");
    }
    //  setIsUploading(false);
  };

  const handleNewUpload = () => {
    // setIsUploading(true);
    resetResumeState();
    document.getElementById("fileInput")?.click();

  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    document.documentElement.scrollTop = 0;
    if (!selectedJobPosition || !jobDescription || !jobId) {
      toast.error("Please select a job position and load the job description.");
      return;
    }
    if (!resume) {
      toast.error("Please upload a resume.");
      return;
    }

    const formData = new FormData();
    formData.append("interview_type", selectedInterviewType);
    formData.append("time_limit", interview_timelimit);
    formData.append("job_id", jobId);
    formData.append("job_role", selectedJobPosition);
    formData.append("job_description", JSON.stringify(jobDescription));
    formData.append("jd_id", selectedID);
    if (customQuestions.length > 0) {
      formData.append("custom_questions", JSON.stringify(customQuestions));
    }
    formData.append("file", resume);
    formData.append("org_id", org_id);

    try {
      if (isBulkUpload) {
        bulkUploadService(formData, accessToken).then(() => {
          toast.success(
            "Uploaded. You will be notified via email once resumes are parsed.",
            { autoClose: 4000 }
          );
          setTimeout(() => {
            window.location.reload();
          }, 4000);
        }).catch((error) => {
          if (error.response) {
            const status = error.response.status;
            const detail = error.response.data.detail;
            if (status === 401) {
              sessionStorage.removeItem("accessToken");
              toast.error(`Unauthorized: ${detail}`);
            } else if (status === 404) {
              toast.warning(`Not Found: ${detail}`);
            } else if (status === 403) {
              const detail = error.response.data.detail;
              const info = typeof detail === "object" && detail ? detail : {};
              // A ZIP with more CVs than screenings left: the message says how many to remove
              setLimitModal({
                open: true,
                featureKey: info.feature_key || null,
                errorCode: info.error_code,
                message: info.message,
                requested: info.requested,
                remaining: info.remaining,
              });
            } else {
              toast.error(`Error: ${detail}`);
            }
          } else {
            toast.error("An unexpected error occurred. Please try again.");
          }
          resetResumeState();
        });

        // resetResumeState();
        return;
      } else {
        setIsScanning(true);
        setScanProgress(0);
        setCustomQuestions(customQuestions);
        const response = await parseResumeService(formData, accessToken);
        if (response.data.Error) {
          toast.error(response.data.Error);
          setIsScanning(false);
          toast.error(response.data.Error);
          setIsScanning(false);
          setResponseScore("ERROR");
          setResponseReport({});
          return;
        }
        const parsedData =
          typeof response.data === "string"
            ? JSON.parse(response.data)
            : response.data;
        const reportData = parsedData.report || {};
        setScanProgress(100);
        await new Promise(resolve => setTimeout(resolve, 500));
        setResponseReport({
          Strengths: Array.isArray(reportData.Strengths)
            ? reportData.Strengths
            : [],
          Weaknesses: Array.isArray(reportData.Weaknesses)
            ? reportData.Weaknesses
            : [],
          Suggestions: reportData.Suggestions || [],
          Recommendation: reportData.Recommendation || [],
          experience_match: Array.isArray(parsedData.experience_match)
            ? parsedData.experience_match
            : [],
          tech_tool_match: Array.isArray(parsedData.tech_tool_match)
            ? parsedData.tech_tool_match
            : [],
          education_match: parsedData.education_match || {},
          red_flags: Array.isArray(parsedData.red_flags)
            ? parsedData.red_flags
            : [],
          location_match: parsedData.location_match || {},
          candidate_profile: Object.fromEntries(
            ["city", "preferred_location", "highest_qualification", "specialization", "total_experience_years", "current_company", "current_designation", "key_skills"]
              .filter((k) => k in parsedData)
              .map((k) => [k, parsedData[k]])
          ),
        });
        setResponseScore(parsedData.score || 0);
        setEmailID(parsedData.email || "");
        setName(parsedData.name || "");
        setMobile(parsedData.mobile || "");
        setInterviewID(parsedData.int_id || "");
        setResumeContent(parsedData.resume_content || "");
        setResumeScoreThreshold(parsedData.resume_score_threshold || 60);
        setResumeS3Url(parsedData.resume_s3_url || "");
        setIsScanning(false);
        setIsUploading(false);
      }
    } catch (error) {
      if (error.response) {
        const status = error.response.status;
        const detail = error.response.data.detail;
        if (status === 401) {
          await new Promise((resolve) => {
            sessionStorage.removeItem("accessToken");
            resolve();
          });
          toast.error(`Unauthorized: ${detail}`);
        } else if (status === 404) {
          toast.warning(`Not Found: ${detail}`);
        } else if (status === 403) {
          const detail = error.response.data.detail;
          const featureKey = typeof detail === "object" ? detail.feature_key : null;
          setLimitModal({ open: true, featureKey });
        } else {
          toast.error(`Error: ${detail}`);
        }
      } else {
        toast.error("An unexpected error occurred. Please try again.");
      }
      setIsScanning(false);
      setIsUploading(false);
      setScanProgress(0);
      setResponseReport({});
    }
  };
  if (isSubmitting) {
    return <Loader />;
  }

  const handleConfirm = async () => {
    setIsConfirmClicked(true);
    setIsCheckboxChecked(true);
    setIsVisible(!isVisible);
  };

  const sendNotification = async (e, customRange = null, scheduleOptions = {}) => {
    if (e && e.preventDefault) e.preventDefault();
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailID) {
      toast.warn("Please enter an email ID");
      return;
    }
    if (!name) {
      toast.warn("Please enter a Name");
      return;
    }
    if (!emailPattern.test(emailID)) {
      toast.error("Please enter a valid email ID");
      return;
    }
    if (!mobile || !isValidPhoneNumber(mobile)) {
      toast.error("Please enter a valid phone number with country code");
      return;
    }

    const [startDate, endDate] = customRange || dateRange;
    if (!startDate || !endDate) {
      toast.warn("Please select a valid interview date range.");
      return;
    }

    // Extract timezone & timeslot from schedule options
    const { timezone, timeslot } = scheduleOptions;
    // Always resolve to a valid IANA timezone string (fallback: browser TZ)
    const resolvedTimezone =
      timezone && timezone.trim()
        ? timezone
        : Intl.DateTimeFormat().resolvedOptions().timeZone;
    // timeslot is null when the user did not select specific time slots
    const resolvedTimeslot = timeslot && timeslot.trim() ? timeslot : null;

    if (!(await confirmCompanyDetails("invite"))) return;

    setIsSchedulePopup(false);
    const formData = new FormData();
    formData.append("interview_id", interviewID);
    formData.append("name", name);
    formData.append("candidate_email", emailID);
    formData.append("mobile", mobile);
    formData.append("mcq_set_id", selectedMCQSet || "");
    formData.append("selected_behavioral_set", selectedBehavioralSet || "");
    formData.append("Coding_Judge_Criteria", codingJudgingCriteria);
    formData.append("coding_set", selectedCodingSet);
    formData.append("mcq_time_limit", MCQTimeLimit);
    formData.append("coding_time_limit", CodingTimeLimit);
    formData.append("typing_time_limit", typingTimeLimit || 0);
    formData.append("start_date", startDate.toISOString());
    formData.append("end_date", endDate.toISOString());
    formData.append("job_id", jobId);
    formData.append("questionType", selectedStyle);
    formData.append("resume_s3_url", resumeS3Url);
    formData.append("job_role", selectedJobPosition);
    formData.append("job_description", JSON.stringify(jobDescription));
    if (customQuestions.length > 0) {
      formData.append("custom_questions", JSON.stringify(customQuestions));
    }
    formData.append("resume_content", resumeContent);
    formData.append("score", responseScore);
    formData.append("interview_type", selectedInterviewType);
    formData.append("interview_timelimit", interview_timelimit);
    // Add analysis data
      formData.append("report", JSON.stringify((({ candidate_profile, ...rest }) => rest)(responseReport)));
      formData.append("education_match", JSON.stringify(responseReport.education_match));
      formData.append("tech_tool_match", JSON.stringify(responseReport.tech_tool_match));
      formData.append("experience_match", JSON.stringify(responseReport.experience_match));
      formData.append("red_flags", JSON.stringify(responseReport.red_flags));
      formData.append("location_match", JSON.stringify(responseReport.location_match));
      formData.append("candidate_profile", JSON.stringify(responseReport.candidate_profile || {}));

      formData.append("orgid",org_id)

    // Timezone: always a valid IANA string (user-selected or system fallback)
    formData.append("timezone", resolvedTimezone);
    // Timeslot: "HH:MM AM/PM" string, or empty string (backend treats as null)
    formData.append("timeslot", resolvedTimeslot ?? "");

    setEmailLoading(true);
    try {
      await axios.post(`${host}/store_candidate_data`, formData, {
        headers: {
          Authorization: `Bearer ${accessToken.toString()}`,
          "Content-Type": "multipart/form-data",
        },
      });
      toast.success("Interview Scheduled Successfully!");
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (error) {
      if (error.response) {
        const status = error.response.status;
        const detail = error.response.data.detail;
        if (status === 401) {
          await new Promise((resolve) => {
            sessionStorage.removeItem("accessToken");
            resolve();
          });
          toast.error(`Unauthorized: ${detail}`);
        } else if(status === 403) {
          const detail = error.response.data.detail;
          const featureKey = typeof detail === "object" ? detail.feature_key : null;
          setLimitModal({ open: true, featureKey });
        }else if (status === 404) {
          toast.warning(`Not Found: ${detail}`);
        } else {
          toast.error(`Error: ${detail}`);
        }
      } else {
        toast.error("An unexpected error occurred. Please try again.");
      }
    } finally {
      setEmailLoading(false);
    }
  };

  const resetResumeState = () => {
    setResume(null);
    setResumeName("");
    setResponseReport({});
    setResponseScore(0);
    setInterviewID("");
    setResumeContent("");
    setResumeS3Url("");
    setIsScanning(false);
    setIsUploading(false);
    setScanProgress(0);
    setEmailID("");
    setMobile("");
    setName("");
    setIsVisible(false);
    setIsCheckboxChecked(false);
    setIsConfirmClicked(false);
    setIsBulkUpload(false);
  };
  const handleCheckboxChange = (e) => {
    setIsCheckboxChecked(e.target.checked);
    if (!e.target.checked) {
      setIsVisible(false);
    }
  };

  const handleTimeFrameChange = (timeFrame) => {
    setTimeFrame(timeFrame);
  };

  if (isEmailLoading) {
    return <EmailLoader isEmailLoading={isEmailLoading}/>;
  }

  const getPathColor = (val) => {
    switch (true) {
      case val >= 60:
        return "#34B53A";
      case val >= 30 && val < 60:
        return "#FFB200";
      case val >= 0 && val < 30:
        return "#DC0000";
      default:
        return "gray";
    }
  };

  const getScoreColorGradient = (score) => {
    switch (true) {
      case score >= 60:
        return "rgba(0,255,0,0.2)";
      case score >= 30 && score < 60:
        return "rgba(255, 255, 0, 0.2)";
      case score >= 0 && score < 30:
        return "rgba(255, 0, 0, 0.2)";
      default:
        return "text-[#CCCCCCE5]";
    }
  };

  const formatJobDescription = (jobRole, data) => {
    // Check if it's a FlexiRole Builder (guided flow) JD by looking for skill_based structure
    if (selectedStyle === "screening" || selectedStyle === "Initial Screening" || selectedStyle === "Bring Your Own Questions") {
      return (
        <pre className="font-sans dark:glass-effect bg-bgSecondary text-md whitespace-pre-wrap break-words p-6 rounded-2xl shadow-inner dark:text-white text-textPrimary">
          {`Job Description:\n${data.Raw_Job_Description || data.job_description || "- None"}\n\n`}
        </pre>
      );
    }
    if (data.Required_Skills?.skill_based) {
      const skillBasedData = data.Required_Skills?.skill_based || [];
      const skillsDisplay = skillBasedData
        .map((skill) => {
          const topics =
            skill.topics && skill.topics.length > 0
              ? ` (${skill.topics.join(", ")})`
              : "";
          return `• ${skill.skill_name}${topics}`;
        })
        .join("\n");

      return (
        <pre className="font-sans dark:glass-effect bg-bgSecondary text-md whitespace-pre-wrap break-words p-6 rounded-2xl shadow-inner dark:text-white text-textPrimary">
          {`Required Skills:\n${skillsDisplay || "- None"}\n\n${
            data.Roles_and_Responsibilities?.length
              ? `Roles & Responsibilities:\n${data.Roles_and_Responsibilities.map(
                  (item, i) => `${i + 1}. ${item}`
                ).join("\n")}`
              : ""
          }\n\n${
            data.Tools_and_Technologies?.length
              ? `Tools & Technologies:\n  ${data.Tools_and_Technologies.join(
                  ", "
                )}\n\n`
              : ""
          }${
            data.GoodtoHave?.length
              ? `Good to Have:\n  ${data.GoodtoHave.join(", ")}\n\n`
              : ""
          }`}
        </pre>
      );
    } else {
      // Handle legacy/QuickRole Builder JDs
      const experience = (data.minExp + data.maxExp) / 2;
      return (
        <pre className="font-sans dark:glass-effect bg-bgSecondary text-md whitespace-pre-wrap break-words p-6 rounded-2xl shadow-inner dark:text-white text-textPrimary">
          {`Required Skills:\n${
            experience < 4
              ? data.Required_Skills?.Medium?.length
                ? data.Required_Skills.Medium.map(
                    (skill, i) => `${i + 1}. ${skill}`
                  ).join("\n")
                : "- None"
              : data.Required_Skills?.Hard?.length
                ? data.Required_Skills.Hard.map(
                    (skill, i) => `${i + 1}. ${skill}`
                  ).join("\n")
                : "- None"
          }\n\nOptional Skills:\n${
            experience < 4
              ? data.Required_Skills?.Easy?.join(", ") || "None"
              : data.Required_Skills?.Medium?.join(", ") || "None"
          }\n\n${
            data.Roles_and_Responsibilities?.length
              ? `Roles & Responsibilities:\n${data.Roles_and_Responsibilities.map(
                  (item, i) => `${i + 1}. ${item}`
                ).join("\n")}`
              : ""
          }\n\n${
            data.Tools_and_Technologies?.length
              ? `Tools & Technologies:\n  ${data.Tools_and_Technologies.join(
                  ", "
                )}\n\n`
              : ""
          }${
            data.GoodtoHave?.length
              ? `Good to Have:\n  ${data.GoodtoHave.join(", ")}\n\n`
              : ""
          }`}
        </pre>
      );
    }
  };

  const formatDateRange = (dateRange) => {
    if (!dateRange[0] || !dateRange[1]) return "Select Date Range";
    return `${dateRange[0].toLocaleDateString()} - ${dateRange[1].toLocaleDateString()}`;
  };

  return (
    <>
      <div className="min-h-screen ">
        <div className="flex-1 min-h-screen rounded-2xl shadow-sm dark:glass-effect bg-bgSecondary p-6 pb-16">
          <div className="flex flex-row items-center justify-between gap-3">
            <div className="flex flex-row gap-3 items-center">
              {location.state?.autoSelectJob && (
                <button
                  onClick={() => navigate(-1)}
                  className="flex items-center gap-2 text-sm dark:text-gray-300 text-textSecondary hover:opacity-80 transition-opacity mb-2"
                >
                  <ArrowLeft className="size-5" />
                </button>
              )}
              <p className="font-sans font-normal text-[20px] leading-[14px] tracking-[0] dark:text-[#FFFFFF]/90 text-textPrimary my-4 pb-2">
                Ready to begin? Pick your job role and then upload your resume
              </p>
            </div>
            <button
              onClick={() => setIsHelpVideoOpen(true)}
              className="w-6 h-6 rounded-full border flex items-center justify-center flex-shrink-0 dark:border-gray-400 border-gray-500 dark:text-gray-400 text-gray-500 text-xs font-semibold hover:opacity-80 transition-opacity"
              title="Help"
            >
              ?
            </button>
          </div>
          <div className="flex items-center justify-between">
            <div>
              <span className="dark:text-[#8893C8] text-textSecondary text-sm">Job Role</span>
              <span className="text-red-500">*</span>
            </div>
            {resume && !isUploading && (
              <button
                onClick={handleNewUpload}
                className="bg-primary text-blue-500 px-5 rounded-full hover:scale-105 transition-transform duration-300"
              >
                Upload New File
              </button>
            )}
           {isUploading && (
              <div className="flex items-center space-x-2">
                <LoaderCircle className="dark:text-[#8893C8] text-textSecondary text-sm animate-spin" />
                <p className="dark:text-[#8893C8] text-textSecondarytext-sm">Uploading...</p>
              </div>
            )}
          </div>
          <div className="flex justify-between space-x-5 mt-2">
            <div className="flex-1">
              <div className="flex items-center space-x-5">
                <div className="flex-1 relative" ref={jobPositionDropdownRef}>
                  <div
                    className="flex items-center justify-between w-full h-12 dark:glass-effect bg-bgPrimary border dark:border-gray-700/50 border-gray-300 rounded-full px-4 py-3 dark:text-gray-300 text-textSecondary dark:hover:bg-gray-700/50  text-sm font-light cursor-pointer"
                    onClick={() => {
                      if (!searchMode) {
                        // Enable search mode and open dropdown on single click
                        setSearchMode(true);
                        setSearchQuery("");
                        setIsJobPositionOpen(true);
                        setTimeout(() => searchInputRef.current?.focus(), 0);
                      }
                    }}
                    onKeyDown={(e) => {
                      // Handle Arrow Keys to navigate dropdown in non-search mode
                      if (
                        !searchMode &&
                        (e.key === "ArrowDown" || e.key === "ArrowUp")
                      ) {
                        e.preventDefault();
                        if (!isJobPositionOpen) {
                          setIsJobPositionOpen(true);
                          setSelectedIndex(
                            e.key === "ArrowDown"
                              ? 0
                              : Object.entries(jobPositions).length - 1
                          );
                        } else {
                          // If already open, navigate
                          const filtered = sortedFilteredPositions;
                          setSelectedIndex((prev) => {
                            const newIndex =
                              e.key === "ArrowDown"
                                ? prev < filtered.length - 1
                                  ? prev + 1
                                  : 0
                                : prev > 0
                                  ? prev - 1
                                  : filtered.length - 1;
                            setTimeout(() => {
                              const listElement = dropdownListRef.current;
                              const selectedElement =
                                listElement?.children[newIndex];
                              if (selectedElement && listElement) {
                                selectedElement.scrollIntoView({
                                  behavior: "smooth",
                                  block: "nearest",
                                });
                              }
                            }, 0);
                            return newIndex;
                          });
                        }
                        return;
                      }

                      if (!searchMode) {
                        // Handle Tab and Enter keys to open dropdown
                        if (e.key === "Tab" || e.key === "Enter") {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            setIsJobPositionOpen(true);
                            setSelectedIndex(0);
                          }
                          // Tab key naturally moves focus, dropdown opens on click/enter
                          return;
                        }

                        // Original functionality: typing characters starts search mode
                        if (e.key.length === 1 && /[a-zA-Z0-9\s]/.test(e.key)) {
                          e.preventDefault();
                          setSearchMode(true);
                          setSearchQuery(e.key);
                          setIsJobPositionOpen(true);
                          setTimeout(() => searchInputRef.current?.focus(), 0);
                        }
                      }
                    }}
                    tabIndex={searchMode ? -1 : 0}
                    data-guide="select-job-role"
                    // Read by the first-run guide to move past steps the user has already done
                    data-guide-job-selected={selectedID ? "true" : "false"}
                    data-guide-resume-added={resume || isScanning || Object.keys(responseReport).length > 0 ? "true" : "false"}
                    role="combobox"
                    aria-expanded={isJobPositionOpen}
                    aria-haspopup="listbox"
                    aria-controls="job-position-listbox"
                    aria-label="Select job position"
                    aria-activedescendant={
                      selectedIndex >= 0
                        ? `job-option-${selectedIndex}`
                        : undefined
                    }
                  >
                    <div className="flex items-center justify-between w-full mr-2">
                      {selectedID && jobPositions[selectedID] && !searchMode ? (
                        <>
                          <span className="truncate">
                            {jobPositions[selectedID].job_role}
                          </span>
                          <span
                            className={`px-2 py-0.5 rounded-full text-[10px] border whitespace-nowrap ${
                              jobPositions[
                                selectedID
                              ].job_description_type?.toLowerCase() === "v1"
                                ? "bg-green-500/20 dark:text-green-300 text-green-600 border-green-500/30"
                                : "bg-purple-500/20 dark:text-purple-300 text-purple-600 border-purple-500/30"
                            }`}
                          >
                            {jobPositions[
                              selectedID
                            ].job_description_type?.toLowerCase() === "v1"
                              ? "Smart Mode (V1)"
                              : "Custom Mode (V2)"}
                          </span>
                        </>
                      ) : searchMode ? (
                        <input
                          ref={searchInputRef}
                          type="text"
                          className="w-full bg-transparent outline-none dark:text-gray-300 text-textSecondary text-sm font-light"
                          placeholder="Search job roles..."
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                          onKeyDown={(e) => {

                            const filtered = sortedFilteredPositions;


                            switch (e.key) {
                              case "ArrowDown":
                                e.preventDefault();
                                setSelectedIndex((prev) => {
                                  const newIndex =
                                    prev < filtered.length - 1 ? prev + 1 : 0;
                                  setTimeout(() => {
                                    const listElement = dropdownListRef.current;
                                    const selectedElement =
                                      listElement?.children[newIndex];
                                    if (selectedElement && listElement) {
                                      selectedElement.scrollIntoView({
                                        behavior: "smooth",
                                        block: "nearest",
                                      });
                                    }
                                  }, 0);
                                  return newIndex;
                                });
                                break;
                              case "ArrowUp":
                                e.preventDefault();
                                setSelectedIndex((prev) => {
                                  const newIndex =
                                    prev > 0 ? prev - 1 : filtered.length - 1;
                                  setTimeout(() => {
                                    const listElement = dropdownListRef.current;
                                    const selectedElement =
                                      listElement?.children[newIndex];
                                    if (selectedElement && listElement) {
                                      selectedElement.scrollIntoView({
                                        behavior: "smooth",
                                        block: "nearest",
                                      });
                                    }
                                  }, 0);
                                  return newIndex;
                                });
                                break;
                              case "Enter":
                                e.preventDefault();
                                if (
                                  selectedIndex >= 0 &&
                                  filtered[selectedIndex]
                                ) {
                                  handleJobPositionChange({
                                    target: {
                                      value: filtered[selectedIndex][0],
                                    },
                                  });
                                  setIsJobPositionOpen(false);
                                  setSearchMode(false);
                                  setSearchQuery("");
                                  setSelectedIndex(-1);
                                }
                                break;
                              case "Escape":
                                setSearchMode(false);
                                setSearchQuery("");
                                setIsJobPositionOpen(false);
                                setSelectedIndex(-1);
                                break;
                            }
                          }}
                          onBlur={() =>
                            setTimeout(() => setIsJobPositionOpen(false), 150)
                          }
                          autoFocus
                        />
                      ) : (
                        <span>
                          Select Job Role{" "}
                          <span className="text-xs text-gray-500"></span>
                        </span>
                      )}
                    </div>
                    <ChevronDown
                      className={`w-4 h-4 flex-shrink-0 transition-transform duration-200 ${isJobPositionOpen ? "rotate-180" : ""}`}
                    />
                  </div>

                  {isJobPositionOpen && (
                    <div
                      className="absolute mt-2 w-full border dark:bg-[#0a1733]   border-gray-300 rounded-md shadow-lg z-10 bg-bgPrimary"
                      style={{
                        backdropFilter: "blur(500px)",
                      }}
                    >
                      <ul
                        ref={dropdownListRef}
                        className="py-1 dark:text-gray-300  text-textSecondary max-h-[200px] overflow-y-auto"
                        id="job-position-listbox"
                        role="listbox"
                      >

                        {isPositionsLoading ? (
                          Array.from({ length: 5 }, (_, i) => (
                              <li key={i} className="px-4 py-2">
                                <Skeleton variant="text" width="100%" />
                              </li>
                            ))
                        ) : (() => {
                          const filtered = sortedFilteredPositions;

                              return filtered.length > 0 ? (
                                filtered.map(([id, position], index) => (
                                  <li
                                    key={id}
                                    className={`px-4 py-2 cursor-pointer transition-colors ${
                                  index === selectedIndex ? 'dark:bg-gray-700 bg-gray-200 dark:text-white text-textSecondary dark:hover:bg-gray-700 hover:bg-gray-100' : 'dark:hover:bg-gray-700 hover:bg-gray-300'
                                    }`}
                                    onClick={() => {
                                  handleJobPositionChange({ target: { value: id } });
                                      setIsJobPositionOpen(false);
                                      setSearchMode(false);
                                  setSearchQuery('');
                                      setSelectedIndex(-1);
                                    }}
                                    onMouseDown={(e) => e.preventDefault()}
                                    onMouseEnter={() => setSelectedIndex(index)}
                                    role="option"
                                    aria-selected={selectedID === id}
                                    id={`job-option-${index}`}
                                  >
                                    <div className="flex items-center justify-between">
                                      <span className="truncate mr-2">
                                        {searchQuery ? (
                                      <span dangerouslySetInnerHTML={{
                                              __html: DOMPurify.sanitize(position.job_role.replace(
                                          new RegExp(searchQuery.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'gi'),
                                                '<mark style="background: rgba(255, 255, 255, 0.2);">$&</mark>'
                                        ))
                                      }} />
                                    ) : position.job_role}
                                      </span>
                                  <span className={`px-2 py-0.5 rounded-full text-[10px] border flex-shrink-0 whitespace-nowrap ${
                                    position.job_description_type?.toLowerCase() === 'v1'
                                      ? 'bg-green-500/20 dark:text-green-300 text-green-600 border-green-500/30'
                                      : 'bg-purple-500/20 dark:text-purple-300 text-purple-600 border-purple-500/30'
                                  }`}>
                                    {position.job_description_type?.toLowerCase() === 'v1' ? 'Smart Mode (V1)' : 'Custom Mode (V2)'}
                                      </span>
                                    </div>
                                  </li>
                                ))
                              ) : (
                                <li className="px-4 py-2 dark:text-gray-300/70 text-textSecondary">
                              <em>{searchQuery ? `No results for "${searchQuery}"` : 'No positions available'}</em>
                                </li>
                              );
                            })()}
                      </ul>
                    </div>
                  )}
                </div>

                { (
                  <div>
                    <button
                      className="button"
                      onClick={() => setIsViewJd(!isViewJd)}
                      disabled = {!selectedJobPosition}
                    >
                      <span>View JD</span>
                    </button>
                  </div>
                )}
              </div>

            </div>
            <div className="flex-1">
              {!isScanning ? (
                <div
                  data-guide="upload-resume"
                  className={`bg-bgPrimary dark:glass-effect   space-y-6 w-full relative rounded-full p-4 cursor-pointer border border-dashed border-[#52525280] ${!jobDescription ? "bg-transparent" : ""}`}
                  onClick={() =>{
                    if(jobDescription){
                       document.getElementById("fileInput")?.click()
                    } else {
                      toast.info("Please select a job role first")
                    }
                  }}
                  onDrop={(e)=>{
                    if(jobDescription){
                      handleDrop(e)
                    } else {
                      toast.info("Please select a job role first")
                    }
                  }}
                  onDragOver={(e)=>{
                    if(jobDescription){
                      handleDragOver(e)
                    } 
                  }}
                >
                  <div className={`flex  items-center justify-center space-x-2 h-4 ${!jobDescription ? "cursor-not-allowed":""}`}>
                    <img
                      src="/headhunting2.png"
                      className={`size-[34px] dark:text-white text-textSecondary ${!jobDescription ? "opacity-30 dark:text-gray-300 text-textSecondary" : ""}`}
                      alt="Upload resume"
                    />
                    <input
                      id="fileInput"
                      type="file"
                      className="hidden"
                      onChange={handleFileChange}
                      accept=".pdf,.docx,.zip"
                    />
                    <div className="text-center ">
                      {resume &&
                      jobDescription &&
                      Object.keys(responseReport).length > 0 ? (
                        <div className="">
                          <div className="flex items-center justify-center space-x-2">
                            {/* <FileText className="size-[34px]  text-gray-300" /> */}
                            <p className="text-[16px] dark:text-gray-300 text-textSecondary font-normal">
                              {resumeName}
                            </p>
                            <div className="h-6 border-l border-gray-400/50" />
                            <p className="text-xs dark:text-gray-400 text-textSecondary font-medium">
                              {isBulkUpload
                                ? "File Uploaded!"
                                : responseScore === "ERROR"
                                  ? "Upload failed. Please try again"
                                  : responseScore === "NA"
                                    ? "Not a valid resume. Please upload another file."
                                    : "Resume Successfully Analyzed"}
                            </p>
                          </div>
                        </div>
                      ) : resume && !jobDescription ? (
                        <>
                          <p className="text-md dark:text-gray-300 text-textSecondary font-normal">
                            {resumeName}
                          </p>
                          <p className="text-xs dark:text-gray-400 text-textSecondary font-medium">
                            Please select a job position to analyze this resume
                          </p>
                        </>
                      ) : (
                        <div className="flex items-center space-x-4">
                          <p className={`text-md ${jobDescription ? 'dark:text-gray-300 text-textSecondary':'dark:text-gray-700 text-gray-200'} font-normal`}>Upload Resume Here</p>

                          {/* Divider */}
                          <div className="h-4 border-l" style={{ borderColor: `${theme === 'dark' ? "#525252":"E5E7EB"}` }} />

                          <p className={`text-xs dark:text-gray-400 ${jobDescription ? 'text-gray-400':'text-gray-200'} font-medium`}>Supports: PDF, Docx, ZIP</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                <div className="space-y-8 h-10 py-6 flex items-center justify-center px-4 relative border border-dashed border-[#52525280] rounded-full">
                  {/* <div className="flex flex-col items-center space-y-4">
                    <div className="relative w-24 h-24">
                      <div className="absolute inset-0 rounded-full border-4 border-teal-500/20" />
                      <div
                        className="absolute inset-0 rounded-full border-4 border-transparent border-t-teal-500"
                        style={{
                          animation: "spin 1s linear infinite",
                        }}
                      />
                      <FileText className="absolute inset-0 m-auto w-12 h-12 text-teal-500" />
                    </div>
                    <div className="text-center">
                      <h4 className="text-lg font-semibold text-gray-300 mb-2">
                        {scanPhase}
                      </h4>
                    </div>
                  </div> */}
                  {/* Old Grad = bg-gradient-to-r from-teal-500 to-green-500 */}
                  <div className="w-full bg-gray-200 rounded-full h-2 overflow-hidden">
                    <div
                      className={`h-full  bg-gradient-to-r from-pink-500 to-blue-500  transition-all duration-300`}
                      style={{ width: `${scanProgress}%` }}
                    />
                  </div>
                  {/* <div className="grid grid-cols-3 gap-4 text-xs text-gray-300">
                    {[
                      "Document Analysis",
                      "Data Extraction",
                      "AI Processing",
                    ].map((step, index) => (
                      <div
                        key={step}
                        className="flex items-center justify-center space-x-2"
                      >
                        {scanProgress >= (index + 1) * 33 ? (
                          <CheckCircle2 className="w-4 h-4 text-teal-500" />
                        ) : (
                          <div className="w-4 h-4 rounded-full border border-teal-300" />
                        )}
                        <span>{step}</span>
                      </div>
                    ))}
                  </div> */}
                </div>
              )}
            </div>
          </div>

          {!isBulkUpload && Object.keys(responseReport).length > 0 && (
            <>
              <h4 className="dark:text-[#8893C8] text-textPrimary text-sm mt-4">Analysis Report</h4>
              <div className="w-full px-4 sm:px-0 pt-5">
                <div className="rounded-3xl dark:shadow-xl shadow-sm p-4 sm:p-6 border border-gray-700/50">
                 {Object.keys(responseReport).length > 0 && (
                  <div className="mb-4">
                  {/* <label className="block text-[#8893C8] text-sm mb-2 mt-6">
                    Candidate Details
                  </label> */}
                    <div className="flex flex-col sm:flex-row gap-2 w-full">
                      <div className="relative w-full sm:w-1/3">                        <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 dark:text-slate-300 text-textSecondary" />
                        <input
                          value={ emailID}
                          type="email"
                          placeholder="Email address"
                          onChange={handleEmailChange}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              e.currentTarget.blur();
                            }
                          }}
                          className={`dark:text-gray-300 ${theme === 'dark' ? "glass-effect" :   "bg-bgSecondary"} text-textSecondary w-full  pl-10 pr-4 py-2 border  dark:border-gray-700/50 border-gray-300 rounded-full focus:outline-none   focus:border-transparent focus:ring-1 focus:ring-gray-400`}
                          aria-label="Candidate email address"
                        />
                      </div>
                       <div className="relative w-full sm:w-1/3">
                        <PhoneInput
                          international
                          // addInternationalOption={false}
                          smartCaret={true}
                          value={mobile}
                          onChange={handleMobileChange}
                          placeholder="Mobile number"
                          className={`dark:text-gray-300 ${theme === 'dark' ? "glass-effect":"bg-bgSecondary"} text-textSecondary w-full px-4 border dark:border-gray-700/50 border-gray-300 rounded-full focus:ring-1 focus:ring-gray-400 focus:border-transparent focus:outline-none`}
                          style={{ height: '42px' }}
                          countryCallingCodeEditable={true}
                          countrySelectComponent={({ value, iconComponent: Icon }) => (
                            <div className="pointer-events-none flex items-center mr-1">
                              {Icon && <Icon country={value} />}
                            </div>
                          )}
                        />
                      </div>
                      <div className="relative w-full sm:w-1/3">
                        <User className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 dark:text-slate-300 text-textSecondary" />
                        <input
                          value={name}
                          type="text"
                          placeholder="Full name"
                          onChange={handleNameChange}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              e.currentTarget.blur();
                            }
                          }}
                          className={`dark:text-gray-300 ${theme === 'dark' ? "glass-effect":"bg-bgSecondary"} text-textSecondary w-full  pl-10 pr-4 py-2 border dark:border-gray-700/50 border-gray-300 rounded-full focus:ring-1 focus:ring-gray-400 focus:border-transparent focus:outline-none`}
                          aria-label="Candidate full name"
                        />
                      </div>
                      
                    </div>
                  </div>
                  )}
                  <div className="flex space-x-6 mt-4 pt-5">
                    <div className="h-36 w-36 relative">
                      <CircularProgressbar
                        value={
                          responseScore === null ||
                          responseScore === undefined ||
                          responseScore === "NA" ||
                          responseScore === "ERROR"
                            ? 0
                            : responseScore
                        }
                        text={
                          responseScore === null ||
                          responseScore === undefined ||
                          responseScore === "NA" ||
                          responseScore === "ERROR"
                            ? "NA"
                            : `${responseScore}%`
                        }
                        circleRatio={0.75}
                        styles={buildStyles({
                          rotation: 1 / 2 + 1 / 8,
                          strokeLinecap: "butt",
                          trailColor:
                            responseScore === null ||
                            responseScore === undefined ||
                            responseScore === "NA" ||
                            responseScore === "ERROR"
                              ? getScoreColorGradient(0)
                              : getScoreColorGradient(responseScore),
                          pathColor:
                            responseScore === null ||
                            responseScore === undefined ||
                            responseScore === "NA" ||
                            responseScore === "ERROR"
                              ? getPathColor(0)
                              : getPathColor(responseScore),
                          textColor: `${theme === 'dark' ? "#FFFFFF" : "#525252"}`,
                          textSize: "20px",
                        })}
                      />
                      <div
                        style={{
                          position: "absolute",
                          width: "100%",
                          textAlign: "center",
                          color: `${theme==='dark' ? "#FFFFFF99" : '#525252'}`,
                          fontSize: "14px",
                          fontWeight: "normal",
                          bottom: "10px",
                        }}
                      >
                        Score
                      </div>
                    </div>
                    <div className="flex-1 flex-col space-y-6 text-white pl-4">
                      <div className="flex-1 flex justify-between">
                        <div className="flex-1 flex flex-col border-r border-[#484474]">
                          <span className="dark:text-[#8893C8] text-textSecondary text-sm font-semibold">
                            Experience Match
                          </span>
                          <div className="dark:text-[#D0D5EF] text-textSecondary mt-2">
                            {Array.isArray(responseReport.experience_match) &&
                            responseReport.experience_match.length > 0 ? (
                              responseReport.experience_match.map(
                                (exp, index) => (
                                  <span
                                    key={index}
                                    style={{
                                      color:
                                        exp.meets_requirement &&
                                        exp.meets_requirement.toLowerCase() ===
                                          "yes"
                                          ? "#34B53A"
                                          : "#DC0000",
                                    }}
                                  >
                                    {exp.candidate_experience}
                                  </span>
                                )
                              )
                            ) : (
                              <span className="dark:text-[#D0D5EF] text-textSecondary">
                                No experience data available
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="flex-1 flex flex-col border-r border-[#484474] pl-5">
                          <span className="dark:text-[#8893C8] text-textSecondary text-sm font-semibold">
                            Location
                          </span>
                          <span className="dark:text-[#D0D5EF] text-textSecondary mt-2">
                            {responseReport.location_match &&
                            Object.keys(responseReport.location_match).length >
                              0
                              ? `${responseReport.location_match.candidate_location.split(
                                    ","
                                  )[0]
                                } `
                              : "No location data available"}
                          </span>
                        </div>
                        <div className="flex-1 flex flex-col pl-5">
                          <span className="dark:text-[#8893C8] text-textSecondary text-sm font-semibold">
                            Education
                          </span>
                          <span className="dark:text-[#D0D5EF] text-textSecondary mt-2">
                            {responseReport.education_match &&
                            responseReport.education_match
                              .candidate_highest_education
                              ? responseReport.education_match
                                  .candidate_highest_education
                              : "No education data available"}
                          </span>
                        </div>
                      </div>
                      <div className="mt-5 border-t border-[#484474]"></div>
                      <div className="flex-1 flex justify-between">
                        <div className="flex flex-col border-r border-[#484474] w-[32%]">
                          <span className="dark:text-[#8893C8] text-textSecondary text-sm font-semibold">
                            Red Flags
                          </span>
                          <span className="dark:text-[#D0D5Ef] text-textSecondary mt-2">
                            {Array.isArray(responseReport.red_flags) &&
                            responseReport.red_flags.length > 0
                              ? responseReport.red_flags.join(", ")
                              : "None"}
                          </span>
                        </div>
                        <div className="flex-1 flex flex-col border-[#484474] pl-5">
                          <span className="dark:text-[#8893C8] text-textSecondary text-sm font-semibold">
                            Tech/ Tools Match
                          </span>
                          <div className="mt-2">
                            {Array.isArray(responseReport.tech_tool_match) &&
                            responseReport.tech_tool_match.length > 0 ? (
                              <div className="flex flex-wrap gap-3">
                                {responseReport.tech_tool_match
                                  // Sort the array to show matches first, then non-matches
                                  .sort((a, b) => {
                                    const aStatus =
                                      a.skill_status.toLowerCase() === "yes";
                                    const bStatus =
                                      b.skill_status.toLowerCase() === "yes";
                                    if (aStatus && !bStatus) return -1;
                                    if (!aStatus && bStatus) return 1;
                                    return 0;
                                  })
                                  .map((skill, index) => (
                                    <SkillBadge
                                      key={index}
                                      skill={skill.skill_name}
                                      status={
                                        skill.skill_status.toLowerCase() ===
                                        "yes"
                                          ? "yes"
                                          : "no"
                                      }
                                    />
                                  ))}
                              </div>
                            ) : (
                              <span className="dark:text-[#D0D5Ef] text-textSecondary">
                                No tech/tools data available
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-5 border-t border-[#484474]">
                    <div className="flex justify-between mt-5">
                      <div className="flex-1 flex flex-col border-r border-[#484474] pr-5">
                        <span className="dark:text-[#8893C8] text-textSecondary text-sm font-semibold">
                          Highlights
                        </span>
                        <span className="dark:text-[#D0D5Ef] text-textSecondary mt-2">
                          {Array.isArray(responseReport.Strengths) &&
                          responseReport.Strengths.length > 0
                            ? responseReport.Strengths.map((point) =>
                                point.replace(/^- /, "").trim()
                              ).join(" ")
                            : "No highlights available"}
                        </span>
                      </div>
                      <div className="flex-1 flex flex-col border-[#484474] pl-5">
                        <span className="dark:text-[#8893C8] text-textSecondary text-sm font-semibold">
                          Lowlights
                        </span>
                        <span className="dark:text-[#D0D5EF] text-textSecondary mt-2">
                          {Array.isArray(responseReport.Weaknesses) &&
                          responseReport.Weaknesses.length > 0
                            ? responseReport.Weaknesses.map((point) =>
                                point.replace(/^- /, "").trim()
                              ).join(" ")
                            : "No lowlights available"}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="mt-5 border-t border-[#484474]">
                    <div className="flex justify-between mt-5">
                      <div className="flex-1 flex flex-col border-r border-[#484474] pr-5">
                        <span className="dark:text-[#8893C8] text-textSecondary text-sm font-semibold">
                          Suggestions
                        </span>
                        <span className="dark:text-[#D0D5EF] text-textSecondary mt-2">
                          {Array.isArray(responseReport.Suggestions) &&
                          responseReport.Suggestions.length > 0
                            ? responseReport.Suggestions.map((point) =>
                                point.replace(/^- /, "").trim()
                              ).join(" ")
                            : "No suggestions available"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              
              {/* {responseScore !== "NA" &&
                (responseScore >= resumeScoreThreshold ||
                  isCheckboxChecked) && (
                  <div className="flex mt-5 justify-end gap-3">
                    <button
                      className="button px-10"
                      onClick={() => setIsDiscardPopupOpen(true)}
                      disabled={isDiscarding}
                      style={{
                        background: isDiscarding
                          ? "#6B7280"
                          : "linear-gradient(to left, #EF4444, #DC2626)",
                        cursor: isDiscarding ? "not-allowed" : "pointer",
                      }}
                    >
                      <span>Discard</span>
                    </button>
                    <button
                      className="button px-10"
                      onClick={saveDraft}
                      disabled={isSavingDraft}
                      style={{
                        background: isSavingDraft
                          ? "#6B7280"
                          : "linear-gradient(to left, #10B981, #059669)",
                        cursor: isSavingDraft ? "not-allowed" : "pointer",
                      }}
                    >
                      <span>
                        {isSavingDraft ? "Saving..." : "Save for Later"}
                      </span>
                    </button>
                    <button
                      className="button px-10"
                      onClick={() => setIsSchedulePopup(!isSchedulePopup)}
                    >
                      <span>Proceed with Interview</span>
                    </button>
                  </div>
                )} */}

                <div className="flex mt-5 justify-end gap-3">
                  {responseScore !== "NA" &&
                responseScore < resumeScoreThreshold && (
                  <div className="flex flex-row items-center space-x-2 justify-center">
                     <AlertCircle className="w-6 h-6 text-yellow-600" />
                     <h4 className="text-sm font-medium text-yellow-600">
                        Low Match Score
                      </h4>
                   
                  </div>
                )}
                    <button
                      className={`border-btn  ${theme === "dark" && 'button !text-black'}`}
                      onClick={() => setIsDiscardPopupOpen(true)}
                      disabled={isDiscarding}
                      style={{
                        backgroundColor:'',
                        cursor: isDiscarding ? "not-allowed" : "pointer",
                      }}
                    >
                      <span className={`${theme === 'dark' ? "text-gray-300":"text-gray-700"}`}>Discard</span>
                    </button>
                    <button
                      className={`border-btn   ${theme === "dark" && 'button !text-black'}`}
                      onClick={saveDraft}
                      disabled={isSavingDraft}
                      style={{
                        // background: isSavingDraft
                        //   ? "#6B7280"
                        //   : "linear-gradient(to left, #10B981, #059669)",
                        cursor: isSavingDraft ? "not-allowed" : "pointer",
                      }}
                    >
                      <span className={`${theme === 'dark' ? "text-gray-300":"text-gray-700"}`}>
                        {isSavingDraft ? "Saving..." : "Save for Later"}
                      </span>
                    </button>
                    <button
                      className="button "
                      data-guide="schedule-interview"
                      onClick={() => {
                        if (!emailID) { toast.warn("Please enter an email ID"); return; }
                        if (!name) { toast.warn("Please enter a Name"); return; }
                        if (!mobile || !isValidPhoneNumber(mobile)) { toast.error("Please enter a valid phone number with country code"); return; }
                        setIsSchedulePopup(!isSchedulePopup);
                      }}
                    >
                      <span>Schedule Interview</span>
                    </button>
                  </div>
            </>
          )}
        </div>
        <Dialog
          open={isDiscardPopupOpen}
          onClose={handleDiscardCancel}
          PaperProps={{
            sx: {
               background:
                `${ theme === 'dark' && "linear-gradient(233.57deg, rgba(34, 52, 97, 0.25) -5.01%, rgba(11, 10, 31, 0.05) 100%)"}`,
              backdropFilter: "blur(50px)",
              WebkitBackdropFilter: "blur(50px)",
              borderRadius: "12px",
              padding: "10px",
              maxWidth: "500px",
              width: "100%",
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
            },
          }}
          BackdropProps={{
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
              transition: "none !important",
            },
          }}
          TransitionProps={{
            timeout: 0,
          }}
        >
          <DialogTitle
            sx={{
              fontFamily: "Poppins",
              color:`${theme === 'dark' ? 'white' : "#525252"}`,
              fontSize: "1.10rem",
              fontWeight: 400,
            }}
          >
            Discard Candidate  ?
          </DialogTitle>
          <DialogContent>
            <Typography
              sx={{
                fontFamily: "Poppins",
               color:`${theme === 'dark' ? 'white' : "#525252"}`,
                fontSize: "0.95rem",
                lineHeight: 1.5,
              }}
            >
              Are you sure you want to discard the candidate data?
            </Typography>
            <IconButton
              aria-label="close"
              onClick={handleDiscardCancel} 
              sx={{
                position: 'absolute',
                right: 8,
                top: '20%',
                transform: 'translateY(-50%)',
                color: theme === 'dark' ? 'white' : '#525252',
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogContent>
          <Box
            sx={{ display: "flex", justifyContent: "flex-end", p: 1, gap: 1 }}
          >
            <Button
              onClick={handleDiscardCancel}
              sx={{ fontFamily: "Poppins", fontWeight: 300, textTransform:'none' }}
              className={`${theme === 'dark' 
                ? 'border border-gray-600 !text-gray-300' 
                : 'border-btn !text-textSecondary'
              }`}
            >
              No
            </Button>
            <Button
              variant="contained"
              onClick={handleDiscardConfirm}
              sx={{
                fontFamily: "Poppins",
                fontWeight: 300,
                background: "linear-gradient(to left, #FB54AE, #2F64FF)",
                color: "white",
                borderRadius: "9999px",
                "&.Mui-disabled": {
                  background: "linear-gradient(to left, #FB54AE, #2F64FF)",
                  opacity: 0.6,
                  color: "white",
                },
                textTransform:'none'
              }}
            >
              Discard
            </Button>
          </Box>
        </Dialog>

        {/* Job Description Modal */}
        {isViewJd && (
          <div className="fixed inset-0 flex items-center justify-center bg-opacity-5 backdrop-blur-xl z-[700] p-4">
            <div
              ref={jdRef}
              className="flex flex-col dark:glass-effect bg-bgSecondary rounded-lg shadow-lg backdrop-blur-[500px] w-full max-w-5xl h-[80vh] relative"
            >
              {/* Fixed Header */}
              <div className="flex justify-between items-start p-6 pb-4 gap-4 flex-shrink-0">
                <div className="flex flex-col">
                  <span className="text-xs tracking-wide text-textSecondary dark:text-gray-400">
                    Job Role
                  </span>
                  <h2 className="text-lg font-semibold text-textPrimary dark:text-white mt-1">
                    {selectedJobPosition || "Job Description"}
                  </h2>
                  {jobDescription?.minExp != null && jobDescription?.maxExp != null && (
                    <span className="text-sm text-textSecondary dark:text-gray-400">
                      {jobDescription.minExp === 0 &&
                        jobDescription.maxExp === 0
                          ? "0 yrs"
                          : `${jobDescription.minExp} - ${jobDescription.maxExp} yrs`}
                    </span>
                  )}
                </div>
                <button
                  onClick={() => setIsViewJd(false)}
                  className="hover:text-opacity-80 dark:text-white text-textPrimary"
                >
                  <X className="w-5 h-5" />
                </button>
              </div>

              {/* Scrollable Content */}
              <div className="px-6 pb-6 space-y-6 overflow-y-auto overflow-x-hidden flex-1">
                {selectedJobPosition && jobDescription ? (
                  <div>
                    {/* Only show Assessment Sequence if there are multiple rounds */}
                    {assessmentSequence?.length > 1 && (
                      <>
                        {/* <h3 className="text-sm font-semibold mb-2 dark:text-[rgba(216, 216, 216, 1)] text-textPrimary">
                          Assessment Sequence
                        </h3> */}
                        <div className="rounded-lg p-4 dark:glass-effect bg-bgPrimary mb-6">
                          <div className="flex">
                            {assessmentSequence.map((step, index) => (
                              <div key={index} className="flex items-center">
                                <span className="dark:text-white text-textSecondary text-sm mx-1">
                                  {String(step).toUpperCase()}
                                </span>
                                <div className="h-6 w-6 rounded-full border flex justify-center items-center mx-2 dark:text-white text-textSecondary">
                                  {index + 1}
                                </div>
                                {index < assessmentSequence.length - 1 && (
                                  <div className="w-14 border border-gray-400"></div>
                                )}
                              </div>
                            ))}
                          </div>
                        </div>
                      </>
                    )}
                    <div>
                      {currentJobDescriptionType === "customized" && customizedJdText
                        ? <pre className="font-sans dark:glass-effect bg-bgSecondary text-md whitespace-pre-wrap break-words p-6 rounded-2xl shadow-inner dark:text-white text-textPrimary">
                          {customizedJdText}
                          </pre>
                        : formatJobDescription(selectedJobPosition, jobDescription)
                      }
                    </div>
                  </div>
                ) : (
                  <p className="dark:text-gray-400 text-textSecondary">Please select a job position</p>
                )}
              </div>
            </div>
          </div>
        )}
        <Dialog
          open={schedulePopupOpen}
          onClose={() => setIsSchedulePopup(false)}
          PaperProps={{
            sx: {
               background:
                `${ theme === 'dark' && "linear-gradient(233.57deg, rgba(34, 52, 97, 0.25) -5.01%, rgba(11, 10, 31, 0.05) 100%)"}`,
              backdropFilter: "blur(50px)",
              WebkitBackdropFilter: "blur(50px)",
              borderRadius: "12px",
              maxWidth: "600px",
              height: "fit-content",
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
            },
          }}
          BackdropProps={{
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
              transition: "none !important",
            },
          }}
          TransitionProps={{
            timeout: 0,
          }}
        >
          {/* <DialogTitle
            sx={{
              fontFamily: "Poppins",
             color:`${theme === 'dark' ? 'white' : "#525252"}`,
              fontSize: "1.10rem",
              fontWeight: 400,
            }}
          >
            Schedule Interview
          </DialogTitle> */}
          <DialogContent sx={{ p: 0 }}>
            <ModernScheduleInterview
              onClose={() => setIsSchedulePopup(false)}
              onConfirm={(data) => {
                // Extract timezone (always set) and timeslot (null when not using specific slots)
                const scheduledTimezone = data.timezone;
                const scheduledTimeslot = data.timeslot || null;
                const calculatedRange = [data.startDate, data.endDate];

                sendNotification(null, calculatedRange, {
                  timezone: scheduledTimezone,
                  timeslot: scheduledTimeslot,
                });
              }}
            />
          </DialogContent>
        </Dialog>
      </div>
      <LimitExceededModal
        isOpen={limitModal.open}
        onClose={() => setLimitModal({ open: false, featureKey: null })}
        featureKey={limitModal.featureKey}
        errorCode={limitModal.errorCode}
        message={limitModal.message}
        requested={limitModal.requested}
        remaining={limitModal.remaining}
      />

      {/* Help tutorial videos — opened via the ? icon */}
      <HelpVideoModal
        open={isHelpVideoOpen}
        onClose={() => setIsHelpVideoOpen(false)}
        videos={HELP_VIDEOS}
        defaultIndex={2}
      />
    </>
  );
};

export default CheckResumeOrgAdmin;